import React from 'react'
import './resume.css'
import img from './img/me.png'
import GetAppIcon from '@material-ui/icons/GetApp'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import BuildIcon from '@material-ui/icons/Build';
import BusinessIcon from '@material-ui/icons/Business'
import { Parallax } from 'react-scroll-parallax';

function Resume() {



    return (
        <div className = 'resume'>
            <Parallax y = {[-35,0]}>
                <div className = 'resume_img'>
                    <img src = {img} alt = 'profilePic'/>
                </div>
            </Parallax>
            <Parallax y = {[100,-100]}>
            <div className = 'resume_text'>
                <div className = 'resume_text_logo'>
                    <AccountCircleIcon fontSize = 'large'/>
                    <h1>About Me</h1>
                </div>
                <p>I'm an IT enthusiast with an immense interest in Web Development, UI design and Machine Learning/Ai.</p>
                <p>A passionate and energetic individual having functional expertise in photoshop, Office Productivity and Computer Troubleshooting.</p>
                <div className = 'resume_text_logo'><BuildIcon fontSize = 'large'/><h1>My Tools.</h1></div>
                <p>FrontEnd Developer (ReactJs,HTML,CSS,Js)</p>
                <p>Backend Developer (Django,firebase service)</p>
                <p>Machine Learning and Ai (python3)</p>
                <p>Security and Linux (Os: Kali Linux)</p>
                <div className = 'resume_text_logo'>
                <BusinessIcon fontSize = 'large'/><h1>Contact Me</h1>
                </div>
                <p>IIIT Bhubaneswar</p>
                <p>Gothapatna</p>
                <p>Odisha</p>
                <p>(+91)9438340718</p>
            </div>
            <div className = 'resume_btn'>
                {/* <Button variant = 'contained' color = 'secondary' href = 'https://github.com/sanketkyrie/resume/raw/master/resume.pdf' download><GetAppIcon/><strong> My Resume</strong></Button> */}
                <a class="coolBeans" href="https://github.com/sanketkyrie/resume/raw/master/resume.pdf"><GetAppIcon fontSize = 'large'/> My Resume</a>           
            </div>
            </Parallax>
        </div>
    )
}

export default Resume
